import NewHeader from 'components/NewHeader';
import { AboutCheckoutProduct } from 'components/About/index';
import HeaderSpaceWrapper from 'components/Common/HeaderSpaceWrapper';
import Footer from 'components/Footer/Footer';
import { AVIFHeadText } from 'global-styles';
import { useRemoveScrollTop } from 'hooks/useRemoveScrollTop';
import Head from 'next/head';
import { useRouter } from 'next/router';
import React from 'react';
import styled from 'styled-components';
import AVIFDetails from 'components/Product/Pulsar/AVIFDetails';
import { AVIFSpeedQualityImgs } from 'components/Product/Pulsar/AvifSQTestCondition';
import { ChevronVerticalIcon } from 'assets/icons';

const metaObj = {
  description: 'AVIF Speed / Quality Benchmark',
};

const AVIFSpeedQualityBenchmarkPage = () => {
  const { push } = useRouter();

  useRemoveScrollTop();

  const handleNavigateBack = () => push('/product/avif/#product-section');

  return (
    <AVIFSpeedQualityBenchmarkPageContainer>
      <Head>
        <title>AVIF Speed/Quality Test Condition - BLUEDOT</title>
        <meta
          name="description"
          content={metaObj.description}
          key="description"
        />
        <meta
          property="og:description"
          content={metaObj.description}
          key="og:description"
        />
        <meta
          property="twitter:description"
          content={metaObj.description}
          key="twitter:description"
        />
      </Head>
      <NewHeader isScrolled />
      <HeaderSpaceWrapper />
      <div className="inner-container">
        <button className="nav-back-btn" onClick={handleNavigateBack}>
          <ChevronVerticalIcon color="#1C1B1F" width="20" height="20" />
        </button>

        <AVIFHeadText className="title-a-s-q-b" as="div">
          AVIF Speed/Quality Test Condition
        </AVIFHeadText>
        <AVIFSpeedQualityImgs />
        <AVIFDetails />
      </div>
      <AboutCheckoutProduct />
      <Footer />
    </AVIFSpeedQualityBenchmarkPageContainer>
  );
};

export default AVIFSpeedQualityBenchmarkPage;

export const AVIFSpeedQualityBenchmarkPageContainer = styled.section`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  overflow-x: hidden;

  & > .inner-container {
    @media screen and (min-width: 1440px) {
      width: 100%;
      max-width: 1048px;
      margin: 142px auto 202px;
    }
    @media screen and (min-width: 1240px) and (max-width: 1439px) {
      width: calc(100% - 192px);
      margin: 142px 96px 202px;
    }
    @media screen and (min-width: 905px) and (max-width: 1239px) {
      width: calc(100% - 112px);
      margin: 142px 56px 202px;
    }
    @media screen and (min-width: 600px) and (max-width: 904px) {
      width: calc(100% - 64px);
      margin: 142px 32px 202px;
    }
    @media screen and (max-width: 599px) {
      width: calc(100% - 32px);
      margin: 142px 16px 202px;
    }
  }
  .title-a-s-q-b {
    margin-top: 44px;
    padding: 32px 0 24px;
    text-align: center;
    margin-bottom: 24px;
    border-bottom: 1px solid #d4d4d4;
  }
  .nav-back-btn {
    width: 96px;
    height: 96px;
    background: #d9d9d9;
    border-radius: 50%;
    transform: rotate(-90deg);
  }
`;
